import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-awesome-lock",
  "use": "icon-awesome-lock-usage",
  "viewBox": "0 0 15 17.143",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 17.143\" id=\"icon-awesome-lock\"><defs><style>#icon-awesome-lock .a{fill:#fff;}</style></defs><path class=\"a\" d=\"M13.393,7.5h-.8V5.089a5.089,5.089,0,1,0-10.179,0V7.5h-.8A1.608,1.608,0,0,0,0,9.107v6.429a1.608,1.608,0,0,0,1.607,1.607H13.393A1.608,1.608,0,0,0,15,15.536V9.107A1.608,1.608,0,0,0,13.393,7.5Zm-3.482,0H5.089V5.089a2.411,2.411,0,1,1,4.821,0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol